import NudosReportLogisticServiceProblem from '../../../../../../components/NudosReportLogisticServiceProblem/NudosReportLogisticServiceProblem';
import { IlogisticServiceDetails } from '../../../../../../types/services';
import DefinitiveEstimatedDates from './DefinitiveEstimatedDates';
import InitialEstimatedDates from './InitialEstimatedDates';
import './LogisticServiceDatesAndProgrammingDetails.scss';

const LogisticServiceDatesAndProgrammingDetails = ({
  logisticServiceData,
  updateDataCallback
}: {
  logisticServiceData: IlogisticServiceDetails;
  updateDataCallback: () => void;
}) => {
  const { collectionInfo, deliveryInfo, statusName } = logisticServiceData;
  const showInitialEstimatedDates = ['por confirmar', 'confirmado', 'en proceso'].includes(statusName || '');
  const displayReportLSProblem = statusName === 'en proceso';
  const requesterComments = collectionInfo?.collectionComment || deliveryInfo?.deliveryComment;

  return (
    <div className="LogisticServiceDatesAndProgrammingDetails">
      <div className="logisticServiceDetailsTab1SectionTitle">Detalles del servicio logístico</div>
      <div className="detailsSection">
        <div className="userInformationContainer">
          <div className="userInformationTitle">Información ingresada por el usuario</div>
          <InitialEstimatedDates logisticServiceData={logisticServiceData} />
          {requesterComments && (
            <>
              <div className="dividerStyles" />
              <div className="requesterCommentsSection">
                <div className="requesterCommentsTitle">Solicitudes del usuario</div>
                <div className="requesterCommentsText">{requesterComments}</div>
              </div>
            </>
          )}
        </div>
        <div className="datesDetailsSection">
          {!showInitialEstimatedDates && (
            <DefinitiveEstimatedDates
              logisticServiceData={logisticServiceData}
              updateDataCallback={updateDataCallback}
            />
          )}
        </div>
        {showInitialEstimatedDates && (
          <NudosReportLogisticServiceProblem
            displayReportLSProblem={displayReportLSProblem}
            logisticServiceDetails={logisticServiceData}
            afterSubmitCallback={updateDataCallback}
          />
        )}
      </div>
    </div>
  );
};

export default LogisticServiceDatesAndProgrammingDetails;
